import { assignTrainings } from 'api/training';
import { debounceUser } from 'utils/debounces';

import type { FormType } from '..';

export const userTrainingForm: FormType = {
  createFn: assignTrainings,
  submitText: 'Atribuir Treinamento',
  cancelText: 'Cancelar',
  successText: 'Treinamento atribuido com sucesso!',
  fields: [
    [{
      name: 'users',
      type: 'select',
      required: true,
      isMultiple: true,
      props: {
        placeholder: 'Buscar',
        label: 'Usuário',
        loadOptions: debounceUser,
      },
    }],
  ],
};
